<label class="control-label text-uppercase montserrat">
  {{titleKey | translate}}
</label>&nbsp;
<kendo-switch [(ngModel)]="advancedMode" (ngModelChange)="onChange($event)"
  attr.aria-label="{{titleKey | translate}}"></kendo-switch>